export function isPrivateIP(){
    const ipPattern = /^(10\.|172\.(1[6-9]|2[0-9]|3[0-1])\.|192\.168\.)/;
    return ipPattern.test(window.location.hostname);
  }

  export function isProduction(){
    return window.location.hostname.indexOf('adacs.com.hk') >= 0
  }